import React from 'react';
import semImagem from '../../Assets/Images/Sem-imagem.png';


class ImagemFukyo extends React.Component {
    constructor(props) {
        super(props);
        this.testImage = this.testImage.bind(this);
        this.flagImagem = false;
        this.state = {
            flagImagem: false
        }
    }

    componentDidMount() {
        if (!!this.props.src) {
            this.testImage(this.props.src);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.src !== this.props.src) {
            this.testImage(this.props.src);
        }
    }

    testImage(url, timeout) {
        const _this = this;
        timeout = timeout || 5000;
        var timedOut = false, timer;
        var img = new Image();
        img.onerror = img.onabort = function () {
            if (!timedOut) {
                clearTimeout(timer);
                _this.setState({ flagImagem: false })
                // console.log(url, "error");
            }
        };
        img.onload = function () {
            if (!timedOut) {
                clearTimeout(timer);
                _this.setState({ flagImagem: true })
                // console.log(url, "success");
            }
        };
        img.src = url;
        timer = setTimeout(function () {
            timedOut = true;
            // reset .src to invalid URL so it stops previous
            // loading, but doesn't trigger new load
            img.src = "//!!!!/test.jpg";
            _this.setState({ flagImagem: false })
            // console.log(url, "timeout");
        }, timeout);
    }

    render() {
        const { className, src, alt } = this.props;
        return (
            <img className={className}
                src={(!!src && this.state.flagImagem) ? src : semImagem} alt={alt}
            />
        )
    }
}

export default ImagemFukyo;